import React from 'react';
import { MultipleChoiceBlock } from '../MultipleChoiceBlock';
import { InstructionsToExtractors } from '../../shared/InstructionsToExtractors';
import { IconAndTitle } from '../../shared/IconAndTitle';
import { HydratedBlockProps } from '../../BaseBlock';
import { AddOtherOptionCheckbox } from './settings/AddOtherOptionCheckbox';

export type MultipleChoiceEditorSettingsProps = {
  block: MultipleChoiceBlock & HydratedBlockProps;
  onChange: (updatedBlock: MultipleChoiceBlock) => void;
};

export const MultipleChoiceEditorSettings = ({
  block,
  onChange,
}: MultipleChoiceEditorSettingsProps): JSX.Element => (
  <>
    <IconAndTitle icon={block.icon} title={block.title} />
    <hr />
    <InstructionsToExtractors block={block} onChange={onChange} />
    <hr />
    <AddOtherOptionCheckbox block={block} onChange={onChange} />
    <hr />
  </>
);
